/**
 * fieldValue — ce que « vide » veut dire pour un champ du builder, et ce qu'on
 * écrit pour le vider.
 *
 * Deux surfaces d'édition en ont besoin et doivent répondre la même chose : le
 * formulaire d'un objet (`FieldRow`) et la pop-in ancrée du canevas
 * (`FieldEditorPopover`). D'où ce module minuscule plutôt qu'une règle
 * recopiée deux fois.
 */

/**
 * La valeur qu'écrit un « Vider ».
 *
 * `null`, et surtout PAS la disparition de la clé : la donnée d'un bloc est
 * fusionnée sous les défauts de sa déf (`{...def.rjBuild.data, ...bloc.data}`,
 * cf. BuilderBlockMount), donc une clé absente laisserait revenir l'image ou
 * le texte d'origine — vider ressusciterait le défaut au lieu d'effacer.
 * `null` traverse l'enrichissement et le presave sans être touché (les deux
 * ne s'intéressent qu'aux tableaux), et ne rend rien à l'écran.
 */
export const EMPTY_FIELD_VALUE = null

/**
 * Le champ porte-t-il quelque chose à effacer ? Sert uniquement à décider si
 * l'affordance « Vider » a lieu d'être — un bouton allumé sur un champ déjà
 * vide est une commande sans effet.
 */
export const hasFieldValue = (value) => {
  if (value == null) return false
  if (typeof value === 'string') return value.trim() !== ''
  if (Array.isArray(value)) return value.length > 0
  if (typeof value === 'object') return Object.keys(value).length > 0
  return true
}
